import { render } from "./Home.page.vue?vue&type=template&id=19038878&ts=true"
import script from "./Home.page.vue?vue&type=script&lang=ts"
export * from "./Home.page.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__